module.exports = "<div class=img-handle-content> <div class=img-div v-if=imgUrl> <img :src=imgUrl id=mainImg class=main-img @mousedown=mousedown($event) @mousemove=mousemove($event) @mouseup=mouseup($event) @mousewheel=mousewheel($event)> </div> <div class=handle-content v-if=imgUrl> <div class=\"handle-img expand-img\" @click=handleImg(1)></div> <div class=\"handle-img narrow-img\" @click=handleImg(2)></div> <div class=\"handle-img rotate-img\" @click=handleImg(3)></div> </div> <div class=img-null v-if=!imgUrl> <span>暂无照片</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/common/img-handle/img-handle.tpl
// module id = 954
// module chunks = 2